export function LogicBoxConstructor(services, type) {

  const joint = services.joint;
  let titleInDiagram;
  switch (type) {
  case 'html.IfThenElseBox':
    titleInDiagram = services.$translate.instant('parameters/quick_replies/details/graph/if_then_else_box_title_in_diagram');
    break;
  case 'html.BHNBHBox':
    titleInDiagram = services.$translate.instant('parameters/quick_replies/details/graph/bh_nbh_box_title_in_diagram');
    break;
  }

  return joint.shapes.html.AbstractBoxWithInPort.extend({
    defaults: joint.util.deepSupplement({
      'labelText': titleInDiagram,
      'labelFill': '#4DAC50',
      'type': type
    }, joint.shapes.html.AbstractBoxWithInPort.prototype.defaults)
  });

}
